export const webSocektUrl = 'szmkapi.coalsmine.com'
// export const webSocektUrl = '123.57.229.166:19963'